import type { TagVariant } from "@amzn/storm-ui";

const enabledVariants: TagVariant[] = [
    "error",
    "success",
    "violet",
    "magenta",
    "redOrange",
    "chartreuse",
];

export const textToVariant = (text: string): TagVariant => {
    const value = [...text].reduce((sum, char) => sum + char.charCodeAt(0), 0);
    return enabledVariants[value % enabledVariants.length];
};
